import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import FolderIcon from '../graphics/folderIcon'
import DoxExplorerFilesTableHeader from './doxExplorerFilesTableHeader'
import { TaxYearTableConfig } from '../services/DoxExplorerTableConfig'
import { shallowEqual } from 'react-redux'

const DoxExplorerTaxYearsTable = (props) => {
    const [sortColumn, setSortColumn] = useState(null)
    const [sortDirection, setSortDirection] = useState(false)
    const [taxYears, setTaxYears] = useState([])    

    const handleSetTaxYear = (tax_year) => {
        props.onSetTaxYear(tax_year)
    }

    const handleSort = (col, dir) => {
        if (sortColumn !== col) {
            setSortColumn(col)
        }
        if (sortDirection !== dir) {
            setSortDirection(dir)
        }
    }

    useEffect(() => {
        if (props.ticket) {
            let tys = props.ticket.relatedTickets ? props.ticket.relatedTickets.map(x => x.taxYear) : []
            tys.push(props.ticket.taxYear)
            tys = tys.sort()
            if (!sortDirection) {
                tys = tys.reverse();
            }
            if (!shallowEqual(tys, taxYears)) {
                setTaxYears(tys);
            }
        }
    }, [props.ticket, sortDirection, taxYears, setTaxYears])

    return (
        <div className='doxe-files-table'>
            <DoxExplorerFilesTableHeader tableConfig={TaxYearTableConfig} sortColumn={sortColumn}
                sortDirection={sortDirection} onSort={handleSort} />
            {taxYears.map(ty =>
                <div className='doxe-files-table-row' key={`doxe-ty-${ty}`}>
                    <div className='dox-link' key={`doxe-ty-${ty}`} onClick={() => handleSetTaxYear(ty)}>
                        <FolderIcon color='#007C10' />
                        {ty}
                    </div>
                </div>
            )}
        </div>
    )
}

DoxExplorerTaxYearsTable.whyDidYouRender = false

DoxExplorerTaxYearsTable.propTypes = {
    onSetTaxYear: PropTypes.func.isRequired,
    ticket: PropTypes.object.isRequired
}   

export default DoxExplorerTaxYearsTable;